function PhysiciansTypeOfPracticeSelectAll() {
    $('#PhysicianTypesOfPractices .Expando :checkbox').prop('checked', $('#SelectAllSpecialties').prop('checked'));
}

function InitilizeDentistTypeOfPractice() {
    $('#DentistsToggleAllTypeOfPractice').click(function() {
        $('#DentistsPractices input:checkbox').prop('checked', $(this).prop('checked'));    
    });

    $('#DentistsPractices input:checkbox').click(function () {
        if ($('#DentistsPractices input:checkbox:checked').length === $('#DentistsPractices input:checkbox').length) {
            $('#DentistsToggleAllTypeOfPractice').prop('checked', true);
        } else {
            $('#DentistsToggleAllTypeOfPractice').prop('checked', false);
        }
    });
    
}